export default __webpack_public_path__ + "static/sunnytrust-banner-24659cd680d1e8bd2f2d58a6398ed9c9.png";